import React from 'react';

import InputMask from 'react-input-mask';

function PhoneMaskCustom(props) {
  return <InputMask {...props} mask="(99) 99999-9999" />;
}

export default PhoneMaskCustom;
